import { render, staticRenderFns } from "./ColorConfigurationSection.vue?vue&type=template&id=7bdfb306&scoped=true"
import script from "./ColorConfigurationSection.vue?vue&type=script&lang=js"
export * from "./ColorConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdfb306",
  null
  
)

export default component.exports